module.exports = __webpack_public_path__ + "img/water-pump.4c0929ce.png";